import { useUpdatePersonalInvitees } from './updatePersonalInviteePanel/utility/useUpdatePersonalInvitees';
import { columns } from './updatePersonalInviteePanel/utility/getColumns';
import { InviteePanel } from '../../../../../components/InviteePanel';

const UpdatePersonalInviteePanel = ({
  hearingId,
  selectedInvitationSource,
}) => {
  const updatePersonalInviteesData = useUpdatePersonalInvitees(
    hearingId,
    selectedInvitationSource,
  );

  return <InviteePanel {...updatePersonalInviteesData} getColumns={columns} />;
};

export { UpdatePersonalInviteePanel };
